const HiStance = {
    TOKEN: 'token',
    LANGUAGE: 'language',
    REFRESH_TOKEN: 'refresh_token',
    SALT: 'salt',
    HANDICAP: 'handicap',
    HANDICAP_DEFAULT_VALUE: 'E',
    SPORTS_ITEM_ACTIVE: 'SPORTS_ITEM_ACTIVE',
    SPORTS_TITLE_ACTIVE: 'SPORTS_TITLE_ACTIVE',
    LANG: 'lang',
    DEVICE: 'device',
    GAME: 'game',
    MERCHANT_ID_TABLE_NAME: 'm',
    SPORT_SINGLE_ACTIVE: 'SPORT_SINGLE_ACTIVE',

    BTN_MONEY_ACTIVE: "btnMoneyActive",
    BTN_MONEY_ACTIVE_OLD: "btnMoneyActiveOld",
    BTN_MONEY_IS_ENABLE: "BTN_MONEY_IS_ENABLE",
    LANGUAGE_SERVICE: "language_service",
    USER_INFO: "userInfo",
    LANGUAGE_LIST: "languageList",
    CONFIG: "config",
    MONEYS_CLONE_DEEP: "moneysCloneDeep",
    SERVER_TIME: "serverTime",
    STOP_TIME: "stopTime",
};

export default HiStance;
